import { Box, Heading, Skeleton, Stack } from "@chakra-ui/react";

import SearchLink from "components/Chakra/SearchLink";
import { useDetailState } from "scenes/OfferDetail";
import { createSearchUrl } from "scenes/Search/createSearchUrl";
import SkeletonOfferReleted from "./components/SkeletonOfferReleted";
import { useGetOfferRelatedQuery } from "@ud/api/newPhpApi/__generated__/newPhpApi.generated";
import OfferSection from "./components/OfferSection";

const RelatedOffers: React.FC = () => {
  const { offer } = useDetailState();
  const { data: offerRelatedData, isLoading } = useGetOfferRelatedQuery({
    offerId: offer?.id,
  });

  if (isLoading) {
    return (
      <>
        <Skeleton as="h2" h="40px" w="250px" mb="40px" mt="60px" />
        <SkeletonOfferReleted />
      </>
    );
  }

  return (
    <Box pb="60px" data-test="offerDetail.related">
      <Stack direction="row" justify="space-between" mb="40px" mt="60px">
        <Heading
          color="ud-grey-600"
          as="h2"
          variant="h3"
          data-test="offerDetail.related.heading"
        >
          Podobné inzeráty
        </Heading>
        <SearchLink
          href={createSearchUrl({
            filter: {},
            location: `${offer?.village?.name}, ${offer?.villagePart?.name}`,
          })}
          variant="button"
          h="fit-content"
          trackEventPayload={{
            "dl.eCat": "offer_detail",
            "dl.eAct": "bttn.clicked",
            "dl.eLab": "Zobrazit inzeráty",
          }}
        >
          Zobrazit vše
        </SearchLink>
      </Stack>
      <OfferSection
        offerItems={offerRelatedData?.data.offers}
        maxW="1210px"
        pl={0}
      />
    </Box>
  );
};

export default RelatedOffers;
